const _excluded = ["children", "className", "color", "disabled", "focused", "ghost", "hovered", "invalid", "padding", "radius", "size", "width"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classNames from 'clsx';
import { AlignTarget } from "../Align";
import { PressableCore } from "./";

const PressableButton = props => {
  const getGhostColor = () => {
    const {
      color,
      disabled,
      hovered
    } = props;

    if (disabled) {
      return 'disabled';
    }

    const initialColor = color === 'base' ? 'default' : color;
    return hovered ? 'hover' : initialColor;
  };

  const getRegularColor = () => {
    const {
      color,
      disabled,
      hovered
    } = props;

    if (color === 'primary') {
      return 'onPrimary';
    } else if (color === 'negative') {
      return 'onNegative';
    } else if (disabled) {
      return 'default';
    }

    return hovered ? 'hover' : 'default';
  };

  const getColor = () => {
    const {
      ghost
    } = props;
    return ghost ? getGhostColor() : getRegularColor();
  };

  const getCursor = () => {
    const {
      disabled
    } = props;
    return disabled ? 'default' : 'pointer';
  };

  const getFill = () => {
    const {
      color,
      ghost
    } = props;

    if (ghost) {
      return;
    } else if (color !== 'base') {
      return color;
    }

    return 'base';
  };

  const getFontSize = () => {
    const {
      size
    } = props;

    if (size === 'small') {
      return 13;
    } else if (size === 'jumbo' || size === 'large') {
      return 16;
    }

    return 14;
  };

  const getFontLineHeight = () => {
    const {
      size
    } = props;

    if (size === 'small') {
      return 16;
    } else if (size === 'jumbo' || size === 'large') {
      return 28;
    }

    return 20;
  };

  const getKeylineColor = () => {
    const {
      color,
      disabled,
      ghost,
      invalid
    } = props;

    if (!disabled && (color === 'base' || ghost) && invalid) {
      return 'negative';
    }

    return color === 'base' ? 'base' : color;
  };

  const getKeyline = () => {
    const {
      ghost
    } = props;
    return ghost ? 'none' : {
      color: getKeylineColor(),
      side: 'all',
      width: 1
    };
  };

  const getOverlay = () => {
    const {
      disabled,
      ghost
    } = props;
    return !ghost && disabled;
  };

  const getPadding = () => {
    const {
      padding,
      size
    } = props;

    if (padding) {
      return padding;
    } else if (size === 'jumbo') {
      return {
        horizontal: 16,
        vertical: 8
      };
    } else if (size === 'large') {
      return {
        horizontal: 12,
        vertical: 4
      };
    }

    return {
      horizontal: 8,
      vertical: 4
    };
  };

  const getShadow = () => {
    const {
      disabled,
      focused,
      ghost,
      hovered
    } = props;
    const baseNonGhostShadow = {
      base: true,
      elevated: true
    };

    if (disabled) {
      // when disabled, the button should not appear focused or hovered
      return ghost ? undefined : baseNonGhostShadow;
    }

    return ghost ? {
      focused
    } : _objectSpread(_objectSpread({}, baseNonGhostShadow), {}, {
      focused,
      hovered
    });
  };

  const {
    children,
    className,
    color,
    disabled,
    focused,
    ghost,
    hovered,
    invalid,
    padding,
    radius,
    size,
    width
  } = props,
        remaining = _objectWithoutProperties(props, _excluded);

  const classes = classNames('PressableButton', className);
  return /*#__PURE__*/React.createElement(AlignTarget, {
    lineHeight: getFontLineHeight(),
    nestable: true // @ts-expect-error - TS2769 - No overload matches this call.
    ,
    padding: getPadding(),
    size: getFontSize(),
    strategy: "x-center"
  }, (alignProps, isAligned) =>
  /*#__PURE__*/
  // $FlowFixMe - go/flowfixme122
  React.createElement(PressableCore, _extends({}, alignProps, remaining, {
    className: classes,
    color: getColor(),
    cursor: getCursor(),
    fill: getFill(),
    fontLineHeight: getFontLineHeight(),
    fontSize: getFontSize(),
    fontWeight: "medium",
    height: size // @ts-expect-error - TS2322 - Type '"none" | { color: string; side: string; width: number; }' is not assignable to type '"none" | PressableCoreKeylineMap | undefined'.
    ,
    keyline: getKeyline(),
    overlay: getOverlay(),
    shadow: getShadow() // @ts-expect-error - TS2322 - Type 'SpacingMap | { horizontal: number; vertical: number; }' is not assignable to type 'SpacingMap | undefined'.
    ,
    padding: getPadding(),
    radius: radius,
    width: width
  }), children));
};

PressableButton.defaultProps = {
  color: 'base',
  disabled: false,
  focused: false,
  ghost: false,
  hovered: false,
  invalid: false,
  radius: 'all',
  size: 'medium',
  width: 'auto'
};
export default PressableButton;